import React from 'react';
import CompanyLogo from '../../components/CompanyLogo';
import Text from '../../components/Text';
import formatCurrency from '../../utils/formatCurrency';

export default function LoanDetailsView({
  companyDisplayName,
  scoringRequest,
  dateApplied,
  status,
  balance,
  primaryEmail,
  goBack,
  confirmLoan,
}) {
  return (
    <div className="loanDetails">
      <h3>{companyDisplayName}</h3>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <CompanyLogo {...scoringRequest} size="medium" />
      <div className="container">
        <div className="row">
          <div className="col-sm detailHeader">
            <Text value="Your Loan Detail" />
          </div>
        </div>
        <div className="row">
          <div className="col-sm left">
            <Text value="Applied on" />
          </div>
          <div className="col-sm right">
            {dateApplied}
          </div>
        </div>
        <div className="row">
          <div className="col-sm left">
            <Text value="Loan Status" />
          </div>
          <div className="col-sm right status">
            <Text value={status} />
          </div>
        </div>
        {balance && (
        <div className="row">
          <div className="col-sm left">
            <Text value="Loan Balance" />
          </div>
          <div className="col-sm right">
            <Text value="currencySymbol" />
            {formatCurrency(balance || 0)}
          </div>
        </div>
        )}
        <div className="row">
          <div className="col-sm left">
            <Text value="Email" />
          </div>
          <div className="col-sm right">
            {primaryEmail}
          </div>
        </div>
        <div className="row">
          <div className="col-sm detailFooter">
            <Text value="Please contact lender if problems found" />
          </div>
        </div>
      </div>
      <button type="button" className="btn btn-secondary" onClick={goBack}>
        <Text value="Go Back" />
      </button>
      <button type="button" className="btn btn-success" onClick={confirmLoan}>
        <Text value="Confirm" />
      </button>
    </div>
  );
}
